import { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTheme } from 'stylesHooks';

function LinkRenderer({
	href,
	children,
}: {
	href?: string | undefined;
	children?: ReactNode;
}) {
	const theme = useTheme();
	return (
		<a
			href={href}
			target="_self"
			rel="noreferrer"
			className="cookiesLink"
			style={{
				fontWeight: theme.typography.body.fontWeight,
				color: theme.palette.primary.main,
			}}
		>
			{children}
		</a>
	);
}

const MarkdownRenderer = ({
	children,
}: {
	children: string | null | undefined;
}) => {
	return (
		<ReactMarkdown components={{ a: LinkRenderer }}>{children}</ReactMarkdown>
	);
};

export { MarkdownRenderer };
